module.exports = __webpack_public_path__ + "img/shower-icon.12eaf97f.svg";